/**
 * Redux-persist compatible storage adapter that routes through safeLocalStorage
 * (consent management). Uses the StrictlyNecessary consent group since the persisted
 * whitelist is critical because of the 'auth' slice.
 */
import { getItem, setItem, removeItem, ConsentGroup } from 'lib/safeLocalStorage'

const consentStorage = {
  getItem(key: string): Promise<string | null> {
    return Promise.resolve(getItem(key))
  },
  setItem(key: string, value: string): Promise<void> {
    setItem(key, value, { consentGroup: ConsentGroup.StrictlyNecessary })
    return Promise.resolve()
  },
  removeItem(key: string): Promise<void> {
    removeItem(key)
    return Promise.resolve()
  },
}

export default consentStorage
